import {
  FooterBox,
  FooterContainer,
  LeftBox,
  Link,
  LinksBox,
  LogoLink,
  ProductsBox,
  RightBox,
  SectionTitle,
  SocialLink,
  SocialLinksBox,
} from './parts'

import { columns, socialLinks } from './data'

import { MaxWidth, usePageMaxWidth } from '../Page'
import { Box } from '../UI/Box'
import { H4 } from '../Library/Typeography'
import { AppToggler } from '../Library/AppToggler'

const Footer = () => {
  const maxWidth = usePageMaxWidth()
  return (
    <FooterContainer>
      <MaxWidth maxWidth={maxWidth} width="100%">
        <FooterBox g={32}>
          <LeftBox dc afs>
            <ProductsBox>
              <Box dc g={16}>
                <H4 s="S">Products</H4>
                <AppToggler asLinks />
              </Box>
            </ProductsBox>
            <LinksBox g={32}>
              {columns.map(({ title, isExternal, link }, i) => (
                <Box key={`footer-col-${i}`}>
                  <Link
                    key={`footer-link-${i}`}
                    href={link}
                    target={isExternal ? '_blank' : '_self'}
                  >
                    {title}
                  </Link>
                </Box>
              ))}
            </LinksBox>
          </LeftBox>
          <RightBox dc>
            <SocialLinksBox dc afe g={32} mw="134px">
              <SectionTitle>Follow us</SectionTitle>
              <Box g={12} jfe fu aw>
                {socialLinks.map(({ title, icon, link }, i) => (
                  <SocialLink
                    href={link}
                    target="_blank"
                    rel="noreferrer"
                    key={`social-link-desktop-${i}`}
                  >
                    <img src={icon} alt={title} />
                  </SocialLink>
                ))}
              </Box>
            </SocialLinksBox>
            <Box dc afe jfe>
              <LogoLink href="https://zap.tech">
                <img src={'/logo-white.svg'} alt="ZAP Logo" />
              </LogoLink>
            </Box>
          </RightBox>
        </FooterBox>
      </MaxWidth>
    </FooterContainer>
  )
}

export default Footer
